import { Route, Routes } from 'react-router-dom';
import { NotFoundError } from '../../main-app/pages/error/NotFoundError';
import { DownloadPage } from '../pages/download';
import { LeadPage } from '../pages/lead';
import { MainPage } from '../pages/main';

export const InvoiceAppRouter = () => {
  return (
    <Routes>
      {/* Client Routes */}
      <Route path={'/'} element={<MainPage />} />
      <Route path={'/summary'} element={<LeadPage />} />
      <Route path={'/download/:invoiceId'} element={<DownloadPage />} />

      <Route path={'*'} element={<NotFoundError />} />
    </Routes>
  );
};
